module.exports = __webpack_public_path__ + "img/arrow_home_consulta.fa3bc0a4.svg";